<template>
  <v-container fluid>
    <v-row>
      <v-col cols="12" class="text-right">
        <v-menu
          offset-y
          :close-on-content-click="false"
          content-class="options-menu"
        >
          <template #activator="{ on, attrs }">
            <v-btn dark large v-bind="attrs" v-on="on">
              <v-icon small>{{ icons.mdiCog }}</v-icon
              >Options
            </v-btn>
          </template>
          <v-list>
            <v-list-item class="pa-0">
              <v-btn
                to="/advisors/add-user"
                depressed
                block
                large
                color="white"
                class="ma-0"
              >
                {{ addUserBtnText }}
              </v-btn>
            </v-list-item>
            <v-list-item v-if="isCompanyAdmin" class="pa-0">
              <v-btn
                depressed
                large
                block
                color="white"
                class="ma-0"
                @click.stop="showCompanyDialog = true"
              >
                Edit company details
              </v-btn>
            </v-list-item>
            <v-list-item v-if="isCompanyAdmin || isAdvisor" class="pa-0">
              <ReferralLink />
            </v-list-item>
            <v-list-item v-if="isSppProvider" class="pa-0">
              <v-btn
                depressed
                large
                block
                color="white"
                class="ma-0"
                @click.stop="showDFASPPLeadDialog = true"
              >
                Create lead
              </v-btn>
            </v-list-item>
          </v-list>
        </v-menu>
      </v-col>
    </v-row>

    <div v-if="isCompanyAdmin">
      <div v-if="!loading">
        <v-row>
          <v-col cols="12">
            <CompanyDetails :company="company" />
          </v-col>
        </v-row>

        <div>
          <v-row class="mt-6" no-gutters>
            <v-col cols="12">
              <h2 class="mt-3">Company users</h2>
            </v-col>
          </v-row>

          <v-row>
            <v-col cols="12">
              <CompanyUsersList
                :company="company"
                :includes-testators="false"
                :show-search-advisor="true"
                @search-advisor="searchAdvisor"
              />
            </v-col>
          </v-row>
        </div>
      </div>

      <div v-else class="text-center">
        <v-progress-circular indeterminate color="primary" />
      </div>
    </div>

    <v-row class="mt-7" no-gutters>
      <v-col cols="12">
        <h2 class="mt-3">Testators</h2>
      </v-col>
    </v-row>
    <v-row>
      <v-col cols="12">
        <TestatorsList
          id="testators-list"
          :company="company"
          :search-advisor-email="searchAdvisorEmail"
        />
      </v-col>
    </v-row>

    <CompanyDialog v-model="showCompanyDialog" :company-to-update="company" />
    <DFASPPLeadDialog v-model="showDFASPPLeadDialog" />
    <SuccessSnackbar v-model="showSuccess" :message="successMessage" />
  </v-container>
</template>

<script>
  import TestatorsList from './TestatorsList.vue';
  import CompanyDialog from './companies/CompanyDialog.vue';
  import { USER_COMPANY_QUERY } from '../../constants/graphql/companies';
  import CompanyDetails from './companies/CompanyDetails.vue';
  import CompanyUsersList from './companies/CompanyUsersList.vue';
  import SuccessSnackbar from '../common/SuccessSnackbar.vue';
  import ReferralLink from './ReferralLink.vue';
  import DFASPPLeadDialog from './DFASPPLeadDialog.vue';

  export default {
    name: 'AdminPage',
    components: {
      TestatorsList,
      CompanyDialog,
      CompanyDetails,
      CompanyUsersList,
      SuccessSnackbar,
      ReferralLink,
      DFASPPLeadDialog,
    },
    props: {
      successMessage: {
        required: false,
        default: null,
        type: String,
      },
    },
    data() {
      return {
        loading: true,
        company: {},
        showCompanyDialog: false,
        showSuccess: false,
        searchAdvisorEmail: null,
        showDFASPPLeadDialog: false,
      };
    },
    computed: {
      isAdmin() {
        return this.$store.getters.isAdmin;
      },
      isCompanyAdmin() {
        return this.$store.getters.isCompanyAdmin;
      },
      isAdvisor() {
        return this.$store.getters.isAdvisor;
      },
      isLeadProvider() {
        return this.$store.getters.isLeadProvider;
      },
      isSppProvider() {
        return this.$store.getters.isSppProvider;
      },
      addUserBtnText() {
        if (this.isAdvisor) {
          return 'Add testator';
        } else {
          return 'Add user';
        }
      },
    },
    created() {
      if (this.successMessage) this.showSuccess = true;
    },
    methods: {
      searchAdvisor(email) {
        this.searchAdvisorEmail = email;
        document
          .getElementById('testators-list')
          .scrollIntoView({ behavior: 'smooth' });
      },
    },
    apollo: {
      company: {
        query: USER_COMPANY_QUERY,
        variables() {
          return {
            id: this.userId,
          };
        },
        fetchPolicy: 'cache-and-network',
        skip() {
          return !this.isCompanyAdmin && !this.isAdvisor;
        },
        update: data => data.user.company,
        result(response) {
          if (response.data) {
            this.loading = false;
          }
        },
      },
    },
  };
</script>
